module.exports = __webpack_public_path__ + "static/media/calendar-sm.1e534ed6.svg";